export default class StaticMaps {

  public static forLocation(location, zoom = 14, size = '1280x640') {
    const params = new URLSearchParams()
    params.set('style', 'feature:poi|element:labels|visibility:off')
    params.set('format', 'webp')
    params.set('maptype', 'roadmap')
    params.set('key', import.meta.env.VITE_GOOGLE_MAPS_API_KEY)
    params.set('center', location)
    params.set('zoom', zoom.toString())
    params.set('scale', '2')
    params.set('size', size)

    return "https://maps.googleapis.com/maps/api/staticmap?" + params.toString()
  }
}